import { inject, observer } from "mobx-react";
import React, { useState, useEffect } from "react";
import { parseQueryString } from "@fidget/common/utils";
import { ICurrentUserStore } from "../../../models/currentUser/CurrentUserStore";
import { AdminSignUpFree } from "./adminSignUpFree";
import { AdminSignUpStripe } from "./adminSignUpStripe";

import { PlanDetails } from "@closerplatform/spinner-openapi";
import { TokenExpiredSection } from "./tokenExpiredSection";
import { config } from "@fidget/common/config/config";

interface Props {
  currentUserStore?: ICurrentUserStore;
  timeout: number;
}

enum DisplayMode {
  completingAccount,
  invitationExpired
}

const getTokenFromQuery = () => {
  const { token } = parseQueryString();
  return token || "";
};

export const AdminSignUpController = inject("currentUserStore")(
  observer(({ currentUserStore, timeout }: Props) => {
    const [planPrice, setPlanPrice] = useState<number>(0);
    const [planCurrency, setPlanCurrency] = useState<string>("USD");
    const [planTrialDuration, setPlanTrialDuration] = useState<number>(0);
    const [displayMode, setDisplayMode] = useState<DisplayMode>(DisplayMode.completingAccount);
    const token = getTokenFromQuery();

    useEffect(() => {
      const loadPlanDetails = async () => {
        await currentUserStore!
          .verifyOrgInvitationByToken(token)
          .then((planDetails: PlanDetails) => {
            if (planDetails.stripePlanDetails !== undefined) {
              const { price, trialDuration, currency } = planDetails.stripePlanDetails;
              setPlanPrice(price);
              setPlanTrialDuration(trialDuration);
              setPlanCurrency(currency);
            }
          })
          .catch(() => setDisplayMode(DisplayMode.invitationExpired));
      };
      loadPlanDetails();
    }, []);

    const renderForms = () => {
      if (planPrice === 0 || !config.services.stripeScriptEnabled) {
        return <AdminSignUpFree timeout={timeout} />;
      }
      return (
        <AdminSignUpStripe
          timeout={timeout}
          currency={planCurrency}
          trialDuration={planTrialDuration}
          price={planPrice}
        />
      );
    };

    switch (displayMode) {
      case DisplayMode.completingAccount:
        return renderForms();
      default:
        return <TokenExpiredSection version={"organisation"} />;
    }
  })
);
